exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".magnifier[data-v-7a1c6b6a]{position:relative;width:450px;height:450px}.magnifier-box[data-v-7a1c6b6a]{position:relative;width:100%;height:100%}.magnifier-box-move[data-v-7a1c6b6a]{position:absolute;height:300px;width:300px;background-color:red;opacity:.2;top:0;left:0;cursor:move}.magnifier-box-img[data-v-7a1c6b6a]{width:100%}.magnifier-big[data-v-7a1c6b6a]{position:absolute;left:460px;top:0;height:550px;width:550px;overflow:hidden}.magnifier-big-img[data-v-7a1c6b6a]{position:relative;width:800px;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a1c6b6a","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/vue-magnifier.vue
// module id = 6
// module chunks = 0